import React from "react";
import Skeleton from "react-loading-skeleton";

const TnspCardSecond = () => {
  return (
    <div className="last-transaction">
      <div className="last-transaction__content">
        <div className="transparent-card__content">
          <Skeleton
            width={"140px"}
            height={"12px"}
            className="custom-skeleton"
            style={{
              // margin:'0px',
              marginTop: "5px",
              backgroundColor: "rgba(255, 255, 255, 0.20)",
            }}
          />
          <Skeleton
            width={"140px"}
            height={"16px"}
            className="custom-skeleton"
            style={{
              margin: "0px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
          <Skeleton
            width={"184px"}
            height={"16px"}
            margin="0px"
            className="custom-skeleton"
            style={{
              margin: "0px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
        </div>
      </div>

      <Skeleton
        width={"64px"}
        height={"64px"}
        circle
        className="custom-skeleton"
        style={{
          marginRight: "10px",
          backgroundColor: "rgba(255, 255, 255, 0.70)",
        }}
      />
    </div>
  );
};

export default TnspCardSecond;
